// extracted by mini-css-extract-plugin
export var disabled = "_81-3";
export var growableInput = "_81-0";
export var tagContainer = "_81-2";
export var textInput = "_81-1";